import localeRepo from "../../../lang";

function isLang(lang) {
  if (!localeRepo[lang]) {
    return false;
  } else {
    return true;
  }
}

function isEntry(lang, value) {
  return !!localeRepo[lang][value];
}

function computeString(original_text, translation_def) {
  if (Array.isArray(translation_def)) {

    let last = translation_def.slice(-1)[0];
    
    last = !!last ? last : "";

    let translation_defs = translation_def.slice(0, -1).map(o => {
      let match = original_text.match(RegExp(o, "g"));
      if (!!match) {
        return match;
      } 
    });

    last = translation_defs.flat().reduce(
      (acc, curr, idx) => acc.replace(`{${idx}}`, curr),
      last
    );

    let nr_regex = 0;
    translation_defs.map(tab_values => {
      last = tab_values.reduce(
        (acc2,curr2,idx2) => acc2.replace(`{${nr_regex}:${idx2}}`, curr2),
        last
      );
      ++nr_regex;
    });

    return last;
  
  } else {
    return translation_def;
  }
}

export function getLocaleString(lang, value, original_text = null) {
  if (!localeRepo) {
    return "<" + lang + ":" + value + ">";
  }
  if (isLang(lang)) {
    if (isEntry(lang, value)) {
      return computeString(original_text, localeRepo[lang][value]);
    } else {
      return "<" + lang + ":" + value + ">";
    }
  } else {
    return "<" + lang + ":" + value + ">";
  }
}

const Text = props => {
  return getLocaleString(props.lang, props.value, props.text);
};
export default Text;
